import { EImportEntity } from '../importer/model';
import { importReducer } from '../importer/reducer';

export const ancillaryTransfersImport = importReducer(EImportEntity.ANCILLARY_TRANSFERS);
